export default {
  EDITOR: 'editor',
  PREVIEW: 'preview',
  SITE: 'site',
  STANDALONE: 'standalone',
};



// WEBPACK FOOTER //
// ./src/widget/constants/edit-modes.js